import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EMPTY, IN_PROGRESS, DONE, ERROR } from "constants/Status";
import { LabelsActionsCreator } from "actions/labelsActionsCreator";
import { getLabelsWithKrn } from "selectors/labelsWithKrn";
import { PayableType } from "types/payable";

export interface IUseLabels {
  loadLabelsWithKrn: (
    clientId: string,
    instanceId: string,
    domain: string,
    realm: string,
    language: string,
    payableTypeDefinitions: PayableType[],
    payableUi: string
  ) => Promise<void>;
  getLabelsWithKrn: any;
  status: string;
}

const useLabelsWithKrn = (): IUseLabels => {
  const dispatch = useDispatch();
  const labelsWithKrn = useSelector(getLabelsWithKrn);
  const [status, setStatus] = useState(EMPTY);

  const loadLabelsWithKrn = async (
    clientId: string,
    instanceId: string,
    domain: string,
    realm: string,
    language: string,
    payableTypeDefinitions: PayableType[],
    payableUi: string
  ) => {
    setStatus(IN_PROGRESS);
    try {
      await new Promise((resolve, reject) => {
        dispatch(
          LabelsActionsCreator.getLabelsWithKrn({
            clientId,
            instanceId,
            domain,
            realm,
            language,
            payableTypeDefinitions,
            payableUi,
            successHandler: resolve,
            failureHandler: reject,
          })
        );
      });
      setStatus(DONE);
    } catch (error) {
      setStatus(ERROR);
    }
  };

  return {
    loadLabelsWithKrn,
    getLabelsWithKrn: () => labelsWithKrn,
    status,
  };
};

export default useLabelsWithKrn;
